import { PIPELINE_API_URL } from '../config';
import { authService } from './authService';

// dqRequest talks to the Go data-pipeline portal (PIPELINE_API_URL), which now
// serves Data Quality live from the v2 schema (app.*/ats.*). Same platform JWT.
async function dqRequest(path, { method = 'GET', params = {} } = {}) {
  const token = authService.requireToken();
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, String(value));
    }
  });
  const response = await fetch(`${PIPELINE_API_URL}${path}${query.toString() ? `?${query.toString()}` : ''}`, {
    method,
    headers: { Authorization: `Bearer ${token}` }
  });
  if (response.status === 401) {
    authService.handleSessionExpired();
    throw new Error('Session expired — please sign in again.');
  }
  if (response.status === 403) throw new Error('You do not have access to Data Quality.');
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || payload.detail || 'Data quality request failed');
  }
  return payload;
}

export const dataQualityService = {
  // Data-quality dashboard — served by the Go portal from the v2 schema. DQ is
  // computed live, so there is no run id in the path (the runId args are ignored).
  getLatest() {
    return dqRequest('/dq/latest');
  },
  getRunTables() {
    return dqRequest('/dq/latest').then((r) => ({ tables: r.tables || [] }));
  },
  getTableDetail(_runId, tableName) {
    return dqRequest(`/dq/tables/${tableName}`);
  },
  getSamples(_runId, tableName, { fieldPairName = null, sampleType = 'improved', provenance = '', page = 1, pageSize = 25 } = {}) {
    return dqRequest(`/dq/tables/${tableName}/samples`, {
      params: {
        field_pair_name: fieldPairName,
        sample_type: sampleType,
        provenance,
        page,
        page_size: pageSize
      }
    });
  },
  recalculate() {
    return dqRequest('/dq/recalculate', { method: 'POST' });
  },

  // Run history (History tab) — served by the Go portal from the baked per-run
  // snapshots. getHistory feeds the trend + run list; getRunHistoryDetail is the
  // per-field drill-down for one run.
  getHistory({ limit = 25, offset = 0 } = {}) {
    return dqRequest('/dq/history', { params: { limit, offset } });
  },
  getRunHistoryDetail(runId, { baseline } = {}) {
    return dqRequest(`/dq/history/${runId}`, { params: { baseline } });
  },
};
